const ru = {
    '例子': 'Пример',
}
export default ru;